export default __webpack_public_path__ + "static/media/footer-top.2148d3d4.png";